import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'

import { FilterAjEvents } from 'containers/filters'
import { apiAjEvents } from 'helpers/decorators/api'
import { AJEventsTable } from 'components/sections/adventurous-journeys'
import { meta, tableCommon } from 'helpers/decorators'

import AjEventsFilter from 'constants/filter-enums/aj-events'

const enhance = compose(
  meta({
    title: 'My AJ Events',
    intlKey: 'pageTitle.my_aj_events'
  }),
  apiAjEvents({
    list: true,
    cache: false,
    filter: AjEventsFilter.myEvents,
    useCommonLimit: true,
    hideIncompleteData: true,
    listReadParams: 'ORGANIZATION_NAME'
  }),
  tableCommon()
)

class AjEventsMy extends Component {
  static propTypes = {
    ajEvents: PropTypes.object.isRequired,
    setMyAjEventsParams: PropTypes.func.isRequired,
    setCommonLimit: PropTypes.func
  }

  render() {
    const { ajEvents, setCommonLimit, ...rest } = this.props
    const { myEvents } = ajEvents

    return (
      <div>
        <FilterAjEvents />
        <AJEventsTable
          {...rest}
          list={myEvents.list}
          loading={myEvents.loading}
          offset={myEvents.offset}
          limit={myEvents.limit}
          setCommonLimit={setCommonLimit}
          pages={myEvents.pages}
          sort={myEvents.sort}
          setAjEventsParams={this.props.setMyAjEventsParams}
        />
      </div>
    )
  }
}

export default enhance(AjEventsMy)
